module.exports = __webpack_public_path__ + "img/team_3.517e71ce.jpg";